export const getLTVChartOptions = (xAxisData, yAxisData) => ({
  chart: {
    type: "line",
    toolbar: {
      show: false,
    },
    fontFamily: "Ubuntu",
    zoom: {
      enabled: false,
    },
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    type: "numeric",
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#edf3f8",
      width: 10,
      offsetX: 0,
      offsetY: 0,
    },
    min: xAxisData.min,
    max: xAxisData.max,
    tickAmount: xAxisData.tickAmount,
    overwriteCategories: Array.from(
      { length: xAxisData.categoriesLength },
      (v, i) => `Renewal ${i}`
    ),
    labels: {
      rotate: -40,
      rotateAlways: xAxisData.rotateLabels,
      show: true,
      style: {
        colors: "#1a344b",
        fontSize: "13px",
        fontFamily: "Ubuntu Mono, sans-serif",
        fontWeight: 400,
      },
    },
    axisBorder: {
      show: false,
    },
  },

  yaxis: [
    {
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#edf3f8",
        width: 10,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        formatter: function (value) {
          return "$" + value;
        },
        align: "right",
        minWidth: 0,
        style: {
          fontSize: "13px",
          fontFamily: "Ubuntu Mono, sans-serif",
        },
      },
      stepSize: Number(yAxisData.max) / 5,
      min: yAxisData.min,
      max: Number(yAxisData.max),
    },
    {
      opposite: true,
      labels: {
        formatter: function () {
          return "";
        },
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#edf3f8",
        width: 50,
        offsetX: 0,
        offsetY: 0,
      },
      stepSize: Number(yAxisData.max) / 5,
      min: yAxisData.min,
      max: Number(yAxisData.max),
    },
  ],
  grid: {
    show: true,
    borderColor: "#edf3f8",
    position: "back",
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: true,
      },
    },
    padding: {
      top: 10,
      right: 10,
      bottom: 10,
      left: 10,
    },
  },
  legend: {
    show: false,
  },
});

export const getLTVChartSeries = (renewalData) => [
  {
    name: "LTV",
    data: renewalData,
    color: "#ffb9f8",
  },
  { data: [], color: "transparent" },
];

export const LTVChartTabs = [
  {
    text: "ARPU",
  },

  {
    text: "ARPPU",
  },

  {
    text: "ARPAS",
  },
];

export const initRenewalData = [
  0.6, 1.4, 1.35, 2.8, 2.7, 3.5, 3.4, 4.2, 4.2, 4.2, 4.2, 4.1, 4.9, 4.9, 4.9,
  4.9, 4.9, 4.9,
];

export const xAxisInitData = {
  min: 1,
  max: 16,
  categoriesLength: 4,
  tickAmount: 3,
  rotateLabels: false,
};

export const yAxisInitData = {
  min: 0,
  max: 5,
};
